/* global Alpine */

// Megamenu Alpine.js component
document.addEventListener('alpine:init', () => {
  Alpine.data('megamenu', () => ({
    headerHeight: 0,
    headerTop: 0,
    isSticky: false,
    lastCalculatedTop: '0px',
    isScrolling: false,
    activeMegamenu: null, // Track which megamenu is currently open

    init() {
      this.detectHeaderType();
      this.calculatePosition();
      this.setupEventListeners();
      this.setupEyesHover();
      this.setupClickOutside();
    },

    // Toggle megamenu open/close
    toggleMegamenu(index) {
      if (this.activeMegamenu === index) {
        // Close if clicking the same menu
        this.activeMegamenu = null;
      } else {
        // Open the clicked menu (and close any other)
        this.activeMegamenu = index;
      }
    },

    // Check if a specific megamenu is open
    isMegamenuOpen(index) {
      return this.activeMegamenu === index;
    },

    // Close all megamenus
    closeAllMegamenus() {
      this.activeMegamenu = null;
    },

    // Setup click outside handler
    setupClickOutside() {
      document.addEventListener('click', (e) => {
        // Check if click is outside header navigation
        const headerNav = document.querySelector('.js-nav-primary');
        if (headerNav && !headerNav.contains(e.target)) {
          this.closeAllMegamenus();
        }
      });
    },

    detectHeaderType() {
      const header = document.querySelector('.js-header');
      if (header) {
        this.isSticky = header.classList.contains('sticky');
      }
    },

    calculatePosition() {
      const header = document.querySelector('.js-header');
      if (!header) return;

      const headerRect = header.getBoundingClientRect();
      this.headerHeight = headerRect.height;
      this.headerTop = headerRect.top;

      // Only update if position actually changed
      const newTop = this.getMegaMenuTop();
      if (newTop !== this.lastCalculatedTop) {
        this.lastCalculatedTop = newTop;
        this.updateMegaMenuPositions(newTop);
      }
    },

    setupEventListeners() {
      // Use requestAnimationFrame for smooth scroll handling
      let ticking = false;

      const handleScroll = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            this.calculatePosition();
            ticking = false;
          });
          ticking = true;
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });

      // Debounced resize listener
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.calculatePosition();
        }, 100); // Reduced from 250ms to 100ms
      });
    },

    setupEyesHover() {
      // Find all megamenu containers that have eyes
      const megaMenus = document.querySelectorAll('.js-megamenu');

      megaMenus.forEach((megaMenu) => {
        const subItems = megaMenu.querySelectorAll('.js-megamenu-sub-item');
        const eyesContainer = megaMenu.querySelector('.js-megamenu-eyes');

        // Only setup hover if both submenu items and eyes container exist
        if (subItems.length && eyesContainer) {
          subItems.forEach((subItem) => {
            subItem.addEventListener('mouseenter', () => {
              eyesContainer.classList.add('eyes-hover');
            });

            subItem.addEventListener('mouseleave', () => {
              eyesContainer.classList.remove('eyes-hover');
            });
          });
        }
      });
    },

    updateMegaMenuPositions(topPosition) {
      const megaMenus = document.querySelectorAll('.js-megamenu');
      if (!megaMenus.length) return;

      // Use transform instead of top for better performance
      megaMenus.forEach((menu) => {
        menu.style.transform = `translateY(${topPosition})`;
        menu.style.top = '0px'; // Reset top to use transform
      });
    },

    getMegaMenuTop() {
      const header = document.querySelector('.js-header');
      if (!header) return '0px';

      const headerRect = header.getBoundingClientRect();

      if (this.isSticky) {
        // For sticky headers, position relative to viewport
        return `${Math.round(headerRect.bottom)}px`;
      } else {
        // For non-sticky headers, calculate position based on visibility
        if (headerRect.bottom > 0) {
          return `${Math.round(headerRect.bottom)}px`;
        } else {
          return '0px';
        }
      }
    },

    // Public method for template use - now returns cached value
    getMegaMenuTopForTemplate() {
      return this.lastCalculatedTop;
    },
  }));
});

// Export for legacy compatibility
export function megamenu() {
  // This is now handled by Alpine.data registration above
  return {};
}
